import { Observable } from 'rxjs'

import { UserProfile } from '@ti/contracts'

export enum UserDirectoryKind {
  Fleet = 'fleet',
  Tsp = 'tsp',
  TspFleet = 'tsp-fleet',
  TiAdmin = 'ti-admin',
  TiTsp = 'ti-tsp',
}

export enum UserStoreEventType {
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Invalidate = 'invalidate',
}

export interface UserStoreFreshnessOptions {
  maxAgeMs?: number
}

export interface UserStoreView<TUser extends UserProfile> {
  readonly items$: Observable<readonly TUser[]>
  readonly byId$: Observable<ReadonlyMap<string, TUser>>
  readonly isLoaded$: Observable<boolean>
  readonly isFresh$: Observable<boolean>
  readonly isRefreshing$: Observable<boolean>

  ensureLoaded(): Promise<void>
  revalidateIfStale(options?: UserStoreFreshnessOptions): Promise<void>
  ensureFresh(options?: UserStoreFreshnessOptions): Promise<void>
  refresh(): Promise<void>
  refreshByIds(ids: string[]): Promise<void>
  getById(id: string): TUser | undefined
  getAll(): readonly TUser[]
  isLoaded(): boolean
  isFresh(): boolean
  isRefreshing(): boolean
}

export type UserStoreEvent =
  | {
      type: UserStoreEventType.Created
      directory: UserDirectoryKind
      user: UserProfile
      fleetId?: number
    }
  | {
      type: UserStoreEventType.Updated
      directory: UserDirectoryKind
      userId: string
      user?: UserProfile
      fleetId?: number
    }
  | {
      type: UserStoreEventType.Deleted
      directory: UserDirectoryKind
      userId: string
      fleetId?: number
    }
  | {
      type: UserStoreEventType.Invalidate
      directory: UserDirectoryKind
      fleetId?: number
    }
